import { Fragment } from 'react'

import { format, parse } from 'date-fns'
import { id } from 'date-fns/locale'
import { CalendarIcon } from 'lucide-react'

import { Button } from './button'
import { FormControl } from './form'
import { MonthPicker } from './month-picker'
import { Popover, PopoverContent, PopoverTrigger } from './popover'

export type YearMonth = `${number}-${number}`

interface InputMonthPickerProps {
  ref?: React.Ref<HTMLButtonElement>
  value: Date | undefined
  onChange: (date: YearMonth | undefined) => void
  asForm?: boolean
  placeholder?: string
  disabled?: boolean
}

export function InputMonthPicker({
  ref,
  value,
  onChange,
  asForm,
  placeholder = 'Pilih Bulan',
  disabled,
}: InputMonthPickerProps) {
  const Wrapper = asForm ? FormControl : Fragment

  let _value: Date | undefined
  // if (value) {
  //   _value = parse(value, 'yyyy-MM', new Date())
  // }
  return (
    <Popover>
      <Wrapper>
        <PopoverTrigger asChild>
          <Button
            ref={ref}
            variant="outline"
            data-empty={!value}
            className="justify-start text-left font-normal data-[empty=true]:text-muted-foreground"
            disabled={disabled}
          >
            <CalendarIcon />
            {value ? (
              format(value, 'MMMM yyyy', { locale: id })
            ) : (
              <span>{placeholder}</span>
            )}
          </Button>
        </PopoverTrigger>
      </Wrapper>
      <PopoverContent className="w-auto p-0">
        <MonthPicker
          currentMonth={_value}
          onMonthChange={(date) => {
            onChange(format(date, 'yyyy-MM') as YearMonth)
          }}
        />
      </PopoverContent>
    </Popover>
  )
}
